import { COLOR_OPTIONS, ColorStyle } from "components/select/lineUtility";
import type { FeatureStyleObject } from "types/firestoreFeatures";

/** Match the editor's colour ID to the map's fallback for unstyled polygons. */
export function getCustomPolygonColorId(styleObject?: FeatureStyleObject | null): ColorStyle {
  const color = COLOR_OPTIONS.find((option) => option.id === styleObject?.fillColor);
  return color ? color.id as ColorStyle : "White";
}
